/* rr-home.js v1 (Sydney, Oct 20 2026)
   Sliders and tabs for the rebuilt homepage sections. Loaded from
   sections/rr-site-styles.liquid with defer.

   Slider markup: a wrapper with data-rr-slider holding a .rr-rail (the row that
   scrolls) and a .rr-rail-nav (arrows and progress line). The row scrolls with
   the finger on its own; this script adds the arrows, keeps the progress line in
   step with the scroll, and hides the controls when everything already fits.

   Tabs markup: a wrapper with data-rr-tabs holding buttons with data-rr-tab="n"
   and panels with data-rr-panel="n". */
(function () {
  'use strict';

  function step(rail) {
    var first = rail.firstElementChild;
    if (!first) return rail.clientWidth;
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function slider(root) {
    if (root.__rrSlider) return;
    var rail = root.querySelector('.rr-rail');
    var nav = root.querySelector('.rr-rail-nav');
    if (!rail || !nav) return;
    root.__rrSlider = true;

    var prev = nav.querySelector('[data-rr-prev]');
    var next = nav.querySelector('[data-rr-next]');
    var bar = nav.querySelector('.rr-rail-nav__bar');
    var jumps = root.querySelectorAll('[data-rr-goto]');

    // Optional buttons that jump to one slide, e.g. the publication names under
    // the press quotes. The one for the slide in view is marked as current.
    jumps.forEach(function (jump) {
      jump.addEventListener('click', function () {
        var n = parseInt(jump.getAttribute('data-rr-goto'), 10) || 0;
        rail.scrollTo({ left: n * step(rail), behavior: 'smooth' });
      });
    });

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (jumps.length) {
        var current = Math.round(rail.scrollLeft / Math.max(step(rail), 1));
        if (rail.scrollLeft > max - 4) current = rail.children.length - 1;
        jumps.forEach(function (jump, i) { jump.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      }
      nav.hidden = max < 4;
      if (nav.hidden) return;
      var share = Math.min(1, rail.clientWidth / rail.scrollWidth);
      var at = max > 0 ? rail.scrollLeft / max : 0;
      bar.style.width = (share * 100) + '%';
      bar.style.transform = 'translateX(' + (at * (1 / share - 1) * 100) + '%)';
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    }

    function go(dir) {
      rail.scrollBy({ left: dir * step(rail), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
    update();
    root.__rrUpdate = update;
  }

  function tabs(root) {
    if (root.__rrTabs) return;
    root.__rrTabs = true;
    var buttons = root.querySelectorAll('[data-rr-tab]');
    var panels = root.querySelectorAll('[data-rr-panel]');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-rr-tab');
        buttons.forEach(function (b) { b.setAttribute('aria-selected', b === button ? 'true' : 'false'); });
        panels.forEach(function (panel) {
          var show = panel.getAttribute('data-rr-panel') === id;
          panel.hidden = !show;
          if (show) {
            var inner = panel.querySelector('[data-rr-slider]');
            if (inner) {
              var rail = inner.querySelector('.rr-rail');
              if (rail) rail.scrollLeft = 0;
              if (inner.__rrUpdate) inner.__rrUpdate();
            }
          }
        });
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rr-slider]').forEach(slider);
    (scope || document).querySelectorAll('[data-rr-tabs]').forEach(tabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
